import { render, staticRenderFns } from "./stayUploadPhotoLoading.vue?vue&type=template&id=f4585546&scoped=true&"
import script from "./stayUploadPhotoLoading.vue?vue&type=script&lang=js&"
export * from "./stayUploadPhotoLoading.vue?vue&type=script&lang=js&"
import style0 from "./stayUploadPhotoLoading.vue?vue&type=style&index=0&id=f4585546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4585546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4585546')) {
      api.createRecord('f4585546', component.options)
    } else {
      api.reload('f4585546', component.options)
    }
    module.hot.accept("./stayUploadPhotoLoading.vue?vue&type=template&id=f4585546&scoped=true&", function () {
      api.rerender('f4585546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/stayUploadPhotoList/stayUploadPhotoLoading.vue"
export default component.exports